import { REDUCER_TYPE, REDUCER_PROPS } from "./LoginRedux";

export const getIsFetching = (state) =>
  state[REDUCER_TYPE][REDUCER_PROPS.IS_FETCHING];
export const getHasError = (state) =>
  state[REDUCER_TYPE][REDUCER_PROPS.HAS_ERROR];
export const getToken = (state) => state[REDUCER_TYPE][REDUCER_PROPS.TOKEN];
export const getIsLoggedIn = (state) =>
  state[REDUCER_TYPE][REDUCER_PROPS.IS_LOGGED_IN];
